export default __webpack_public_path__ + "static/media/connected-indicator 2.2e08e8e9.svg";